import { render, staticRenderFns } from "./ProductFeeConfigFixedList.vue?vue&type=template&id=6fb5d072&scoped=true"
import script from "./ProductFeeConfigFixedList.vue?vue&type=script&lang=js"
export * from "./ProductFeeConfigFixedList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb5d072",
  null
  
)

export default component.exports